<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{ error: NuxtError }>()
</script>

<template>
  <UApp>
    <UError :clear="{ label: 'Back to find a claim' }" :error="error" />
  </UApp>
</template>
